export default __webpack_public_path__ + "img/b29850cbf91c58d21124363033280094.png";